import { defineMessages } from 'react-intl'

const headingMessages = defineMessages({
  wait: {
    id: 'Modal.Heading.Wait',
    defaultMessage: "Wait! You're about to lose some work."
  },
  cancelReview: {
    id: 'Modal.Heading.CancelReview',
    defaultMessage: 'Cancel your review?'
  },
  almostDone: {
    id: 'Modal.Heading.AlmostDone',
    defaultMessage: 'Almost Done!'
  },
  returningToQuestDesigner: {
    id: 'Modal.Heading.ReturningToQuestDesigner',
    defaultMessage: 'Returning to Quest Designer'
  },
  readyForPublish: {
    id: 'Modal.Heading.ReadyForPublish',
    defaultMessage: 'Ready for Publishing'
  },
  reviewInProgress: {
    id: 'Modal.Heading.ReviewInProgress',
    defaultMessage: 'Review in Progress'
  },
  thisQuestIsPublished: {
    id: 'Modal.Heading.ThisQuestIsPublished',
    defaultMessage: 'This quest is published'
  }
})

const bodyMessages = defineMessages({
  youreLeaving: {
    id: 'Modal.Body.YoureLeaving',
    defaultMessage:
      "You're leaving an area that you were editing. Are you sure you want to leave? If so, your unsaved work will be lost."
  },
  questOneStepCloser: {
    id: 'Modal.Body.questOneStepCloser',
    defaultMessage:
      'Thanks! Your quest is one step closer to eager learners. It will now be reviewed by members of your organization for experience, subject, and copy.'
  },
  ifYouCancel: {
    id: 'Modal.Body.IfYouCancel',
    defaultMessage:
      'If you cancel now, your review will be deleted, so another reviewer can have a fresh start. However, any comments you left throughout the quest will remain. Are you sure you want to cancel?'
  },
  thanksForYourReviewOE: {
    id: 'Modal.Body.ThanksForYourReviewOE',
    defaultMessage:
      'Thanks for your review! This quest will now return to the Publication Review queue so it can move into the final phase of review.'
  },
  internalReviewsDone: {
    id: 'Modal.Body.InternalReviewsDone',
    defaultMessage:
      'Internal reviews are done! Your review was the last one needed from your organization. Now, the quest will move on to Publication Review.'
  },
  questNeedsEdits: {
    id: 'Modal.Body.QuestNeedsEdits',
    defaultMessage:
      'Thanks for your review! This quest needs edits, so it will be returned to the quest designer now.'
  },
  passedAllReviews1: {
    id: 'Modal.Body.PassedAllReviews1',
    defaultMessage: 'This quest has passed all the necessary reviews. Tap '
  },
  passedAllReviews2: {
    id: 'Modal.Body.PassedAllReviews2',
    defaultMessage: 'Publish'
  },
  passedAllReviews3: {
    id: 'Modal.Body.PassedAllReviews3',
    defaultMessage:
      ' below to make it available to learners and mentors in Quest!.'
  },
  ifYouStop1: {
    id: 'Modal.Body.IfYouStop1',
    defaultMessage:
      'If you stop this review, this quest will be revoked from the reviewer and returned to the '
  },
  ifYouStop2: {
    id: 'Modal.Body.IfYouStop2',
    defaultMessage: 'Draft'
  },
  ifYouStop3: {
    id: 'Modal.Body.IfYouStop3',
    defaultMessage:
      "state. When it's submitted for review again, you will have to start the review process from the beginning."
  },
  toEditThisQuest: {
    id: 'Modal.Body.ToEditThisQuest',
    defaultMessage:
      'To edit this quest, a new draft version of the quest will be created for you to work on. The published version of the quest will remain in use by students and mentors. (If you need to remove the published version from circulation, please contact the Quest Forward team at,'
  }
})

const buttonMessages = defineMessages({
  leaveAnyway: {
    id: 'Modal.Button.LeaveAnyway',
    defaultMessage: 'Leave anyway'
  },
  cancel: {
    id: 'Modal.Button.Cancel',
    defaultMessage: 'Cancel'
  },
  ok: {
    id: 'Modal.Button.OK',
    defaultMessage: 'OK'
  },
  yes: {
    id: 'Modal.Button.Yes',
    defaultMessage: 'Yes'
  },
  no: {
    id: 'Modal.Button.No',
    defaultMessage: 'No'
  },
  publish: {
    id: 'Modal.Button.Publish',
    defaultMessage: 'Publish'
  }
})

export { headingMessages, bodyMessages, buttonMessages }



// WEBPACK FOOTER //
// ./src/utils/messages/modal.js